import { Component, OnInit } from '@angular/core';
import { ImageuploadService } from '../../../Imageupload.service';
import { LoginService } from '../../../login-service';


@Component({
  selector: 'app-adminprofile',
  templateUrl: './adminprofile.component.html',
  styleUrls: ['./adminprofile.component.scss']
})
export class AdminprofileComponent implements OnInit {
userid:string;
userprofiledata:any;
usertype:string;
  usersList: any;
  fullname: any;
  email: any;
  userprofile: any;
  url: string;
  imagefile: void;
  ProfilePic: any;
  constructor(private loginservice:LoginService,public imageservice: ImageuploadService) {
    this.usertype=localStorage.getItem("userTypeid");
   }

  ngOnInit(): void {
    this.userid=localStorage.getItem('userID');

    this.getuserprofile();
    
  }
  openclick(event:any)
  {
   event.preventDefault();
   let element:HTMLElement=document.getElementById('uploadpic') as HTMLElement;
   element.click();
  }
  fileChange1(input,param) {
    
      
    this.imagefile = this.loginservice.filechange1(input, param,this.userid);
  
    this.imageservice.ImageUplode1.subscribe(Img =>{ 
      this.ProfilePic = Img
    });
    
     
  }
  getuserprofile()
  {
    this.loginservice.GetUsers(this.usertype).subscribe(data=>
      {
        data = JSON.parse(data['_body']);
        this.usersList = data;
      
        let userprofiledata=this.usersList.filter(x=>x.id==this.userid);
       
        this.fullname=userprofiledata[0].user_name;
       
        if(userprofiledata[0].Profile!==null ){
          //  this.url="http://localhost:25396/"; 
          this.url=this.loginservice.imageURL;
          this.userprofile=userprofiledata[0].Profile;
          }
          else if(userprofiledata[0].Profile===null ){
          this.url="";
          this.userprofile='/assets/images/user.png';
          }
         
        this.email=userprofiledata[0].email;
        
      });
  }

  Reset()
  {
    this.fullname="";
    this.email="";
  }

  save()
  {
    const json={
      usernameparm:this.fullname,
      emailparm:this.email,
      useridparm:this.userid,
      firstnameparm:"",
      lastnameparm:"",
      passwordparm:"",
      usertypeidparm:"",
      socialuserparm:""
      
    }
  
    this.loginservice.SaveUsers(json).subscribe(data=>{
      
     
    }
    );
  }

}
